/** @jsx jsx */
import { jsx, Styled, Container } from 'theme-ui'
import SectionHeading from './section-heading'
import FlexList from './flex-list'
import SponsorCard from './sponsor-card'
import groupBy from 'lodash.groupby'


export default ({
  sponsors = []
}) => {
  const tiers = groupBy(sponsors, 'tier')
  return(
    <div
      id='sponsors'
      sx={{ py: 5 }}>
      <Container>
        <SectionHeading>
          Sponsors
        </SectionHeading>
        {Object.keys(tiers).map(tier => (
          <div key={tier}>
            <Styled.h2>
              {tier}
            </Styled.h2>
            <FlexList
              sx={{
                justifyContent: 'left',
              }}
            >
              {tiers[tier].map(sponsor => (
                // <Card as='li' key={sponsor.id}>
                //   <Styled.a
                //     title={sponsor.name}
                //     href={sponsor.url}>
                //     <Styled.img
                //       src={sponsor.logo}
                //     />
                //   </Styled.a>
                // </Card>
                <SponsorCard
                  key={sponsor.id}
                  as='li'
                  {...sponsor}
                />
              ))}
            </FlexList>
          </div>
        ))}
      </Container>
    </div>
  )
          }
